import styled from 'styled-components';

import { Color } from '../../theme';
import { HeaderH4 } from '../../uiComponents';

export const LinkBox = styled.a`
  padding: 30px 45px 35px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: ${Color.primary};
  color: ${Color.white};
  font-size: 20px;
  letter-spacing: 0;
  line-height: 28px;
  min-height: calc(200px - 65px);
  text-decoration: none;
  position: relative;
  &:after {
    content: '';
    background-color: ${Color.black};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: 0.3s;
  };
  &:hover {
    &:after {
      opacity: 0.05;
    };
  };
`;

export const LinkBoxLabel = styled.div`
  padding-bottom: 35px;
`;

export const ArrowIcon = styled.img``;
